export type ClerkGetToken = (options?: { template?: string; skipCache?: boolean }) => Promise<string | null>;

export const getClerkToken = async (
  getToken: ClerkGetToken,
  template = 'synaptivoice-api',
  options?: { skipCache?: boolean }
): Promise<string | null> => {
  if (!getToken) {
    return null;
  }

  try {
    const token = await getToken({
      template,
      ...(options?.skipCache ? { skipCache: true } : {}),
    });
    if (token) {
      return token;
    }
  } catch (error) {
    console.warn('Clerk token template failed; falling back to default token.', error);
  }

  try {
    return await getToken(options?.skipCache ? { skipCache: true } : undefined);
  } catch (error) {
    console.warn('Clerk default token failed.', error);
    return null;
  }
};
